// Inicialização do Slick carousel
/*
$('.product-shelf-slider-carousel').slick({
slidesToShow: 4,
slidesToScroll: 4, 
infinite: true,
dots: true, 
arrows: true,  
responsive: [
  {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 300,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
]
});
*/

/*Usando o Splide slide nas vitrines de carousel, pois o slick remontava o bloco(html), fazendo com que ocasionasse erro na primeira validação de seleção de variação de tamanho da vitrine*/
document.querySelectorAll('.splide').forEach(function(slider) {
  const splideInstance = new Splide(slider, {
    type       : 'slide',          // Tipo de carrossel
    perPage    : 4,                // Quantidade de slides visíveis por vez
    perMove    : 4,                // Quantidade de slides que se movem ao deslizar
    rewind     : true,             // Para que o carrossel seja infinito
    pagination: true,              // Dots de navegação
    arrows     : true,             // Setas de navegação
    breakpoints: {
      1024: {
        perPage: 3,              // Para telas menores que 1024px
        perMove: 3
      },
      768: {
        perPage: 2,              // Para telas menores que 768px
        perMove: 2
      },
      300: {
        perPage: 1,              // Para telas menores que 300px
        perMove: 1
      }
    }
  }).mount();

  // Capturando as setas de navegação
  const prevArrow = slider.querySelector('.splide__arrow--prev');
  const nextArrow = slider.querySelector('.splide__arrow--next');

  // Monitorando o movimento do slider para ativar/desativar as setas
  splideInstance.on('move', function(index) {
    // Desabilitar a seta "anterior" se o slider estiver no primeiro item
    if (index === 0) {
      prevArrow.setAttribute('aria-disabled', 'true');
      prevArrow.setAttribute('tabindex', '-1');
    } else {
      prevArrow.removeAttribute('aria-disabled');
      prevArrow.removeAttribute('tabindex');
    }

    // Desabilitar a seta "próximo" se o slider estiver no último item
    if (index === splideInstance.length - 1) {
      nextArrow.setAttribute('aria-disabled', 'true');
      nextArrow.setAttribute('tabindex', '-1');
    } else {
      nextArrow.removeAttribute('aria-disabled');
      nextArrow.removeAttribute('tabindex');
    }
  });
});



// Função para selecionar automaticamente a primeira variação
function initializeVariantSelection() {
    // Seleciona todos os elementos com a classe .product-item
    const productItems = document.querySelectorAll('.product-item');
    
    // Verifica se existem elementos com a classe .product-item
    if (productItems.length > 0) {
        productItems.forEach(function(productItem) {
            // Dentro de cada .product-item, encontra o .product-options
            const productOptionsDiv = productItem.querySelector('.product-options');
            
            // Verifica se o .product-options existe
            if (productOptionsDiv) {
                const productId = productOptionsDiv.getAttribute('data-product-id');
                
                // Seleciona a primeira variação de cor
                const firstColorInput = document.querySelector(`input[name^="variant-${productId}-1"]`);
                if (firstColorInput) {
                    firstColorInput.checked = true;
                    // Encontrar o parent que é o label e disparar o clique
                    const colorLabel = firstColorInput.closest("label"); // Procura o label mais próximo (caso o input esteja dentro de um label)
                    if (colorLabel) {
                      colorLabel.click(); // Simula o clique no label
                    }
                }

             
                // Seleciona a primeira variação de tamanho

                /*
                const firstSizeInput = document.querySelector(`input[name^="variant-${productId}-2"]`);
                if (firstSizeInput) {
                    //firstSizeInput.checked = true;
                    // Encontrar o parent que é o label e disparar o clique
                    const sizeLabel = firstSizeInput.closest("label:not(.unavailable)"); // Procura o label mais próximo
                    if (sizeLabel) {
                     sizeLabel.click(); // Simula o clique no label
                    }
                }
              */
            }
        });
    }
}


// Inicializa as seleções ao carregar a página
setTimeout(function(){
  initializeVariantSelection();
},1000);


// Manipulando o clique no botão de Adicionar ao Carrinho
const addToCartButtons = document.querySelectorAll('.add-to-cart-button');

addToCartButtons.forEach(function(button) {
    button.addEventListener('click', function(event) {
        // Pega o ID do produto diretamente do botão
        const productId = button.getAttribute('data-product-id');
        if (!productId) {
            console.error('Não foi possível encontrar o productId no botão');
            return; // Se não encontrar o productId, sai da função
        }

        // Captura as variantes (cor e tamanho) dentro do produto
        const size = document.querySelector(`input[name^="variant-${productId}-2"]:checked`);
        const color = document.querySelector(`input[name^="variant-${productId}-1"]:checked`);

        // Se não encontrar as opções selecionadas, exibe mensagem de erro
        if (size && color) {
            const selectedSize = size.value;
            const selectedColor = color.value;

            console.log("Tamanho selecionado:", selectedSize);
            console.log("Cor selecionada:", selectedColor);

            // Encontre a div de variantes específica para o produto
            const productOptionsDiv = document.querySelector(`.product-options[data-product-id="${productId}"]`);
            if (!productOptionsDiv) {
                console.error('Produto não encontrado para variantes:', productId);
                return;
            }

            // Verifique o valor de data-variants
            const variantsString = productOptionsDiv.getAttribute('data-variants');
            console.log("Variants String:", variantsString); // Log para verificar o JSON

            // Tente fazer o parse do JSON e capturar erros
            let productVariants;
            try {
                productVariants = JSON.parse(variantsString);
                console.log("Variants JSON:", productVariants); // Verifica a estrutura do JSON
            } catch (e) {
                console.error('Erro ao fazer o parse do JSON:', e);
                return; // Sai da função se o JSON estiver mal formatado
            }

            // Agora buscamos a variante correta
            const selectedVariant = productVariants.find(function(variant) {
                console.log("Comparando:", variant.option1, variant.option2);

                // Garantir que estamos fazendo a comparação correta de tamanho e cor
                return variant.option1 === selectedColor && variant.option2 === selectedSize;
            });

            if (selectedVariant) {
                // Verificar se a variante tem estoque
                if (selectedVariant.available) {
                    // Adicionar a variante ao carrinho usando a API do Shopify
                    fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            items: [{
                                id: selectedVariant.id,
                                quantity: 1
                            }]
                        })
                    }).then(response => {
                        //alert('Produto adicionado ao carrinho!');
                        const event = new Event('product:added');
                        document.dispatchEvent(event);
                    }).catch(error => {
                        console.error('Erro ao adicionar ao carrinho:', error);
                    });
                } else {
                    // Se não houver estoque, desabilitar o botão
                    button.disabled = true;
                    button.classList.add('out-of-stock'); // Adiciona uma classe CSS para estilizar o botão

                    // Também podemos adicionar uma classe visual nas variações sem estoque
                    const variantInputs = document.querySelectorAll(`input[name^="variant-${productId}"]`);
                    variantInputs.forEach(function(input) {
                        // Verificar se a variação corresponde àquela sem estoque
                        const variantId = input.value;
                        const variant = productVariants.find(v => v.option1 === selectedColor && v.option2 === selectedSize);
                        if (variant && !variant.available) {
                            input.parentElement.classList.add('out-of-stock'); // Adiciona classe na variação sem estoque
                        }
                    });

                    alert('Esta variação está fora de estoque.');
                }
            } else {
                console.error('Seleção inválida de variante');
                alert('Seleção inválida de variante.');
            }
        } else {
            alert('Por favor, selecione uma cor e um tamanho.');
        }
    });

    // Lidar com a mudança de seleção das variações (cor ou tamanho)
    const sizeInputs = document.querySelectorAll(`input[name^="variant-${button.getAttribute('data-product-id')}-2"]`);
    const colorInputs = document.querySelectorAll(`input[name^="variant-${button.getAttribute('data-product-id')}-1"]`);
    
    sizeInputs.forEach(input => {
        input.addEventListener('change', function() {
            validateVariantStock(button, 'size'); // Chama a função de validação passando 'size'
        });
    });
    
    colorInputs.forEach(input => {
        input.addEventListener('change', function() {
            validateVariantStock(button, 'color'); // Chama a função de validação passando 'color'
        });
    });
});

// Função para validar o estoque da variante selecionada
function validateVariantStock(button, trigger) {
    const productId = button.getAttribute('data-product-id');
    const size = document.querySelector(`input[name^="variant-${productId}-2"]:checked`);
    const color = document.querySelector(`input[name^="variant-${productId}-1"]:checked`);

    // Verificar se tanto o tamanho quanto a cor foram selecionados
    if (size && color) {
        const selectedSize = size.value;
        const selectedColor = color.value;

        const productOptionsDiv = document.querySelector(`.product-options[data-product-id="${productId}"]`);
        const variantsString = productOptionsDiv.getAttribute('data-variants');
        let productVariants;
        try {
            productVariants = JSON.parse(variantsString);
        } catch (e) {
            console.error('Erro ao fazer o parse do JSON:', e);
            return;
        }

        if (trigger === 'size') {
            // Quando o tamanho é alterado, varre as cores
            const colorInputs = document.querySelectorAll(`input[name^="variant-${productId}-1"]`);
            colorInputs.forEach(input => {
                const selectedColor = input.value;
                const variant = productVariants.find(v => v.option1 === selectedColor && v.option2 === selectedSize);
                if (variant) {
                    if (variant.available) {
                        input.parentElement.classList.remove('out-of-stock');
                    } else {
                        input.parentElement.classList.add('out-of-stock');
                    }
                }
            });
        } else if (trigger === 'color') {
            // Quando a cor é alterada, varre os tamanhos
            const sizeInputs = document.querySelectorAll(`input[name^="variant-${productId}-2"]`);
            sizeInputs.forEach(input => {
                const selectedSize = input.value;
                const variant = productVariants.find(v => v.option1 === selectedColor && v.option2 === selectedSize);
                if (variant) {
                    if (variant.available) {
                        input.parentElement.classList.remove('out-of-stock');
                    } else {
                        input.parentElement.classList.add('out-of-stock');
                    }
                }
            });
        }
    }
}



/*
document.querySelectorAll('.add-to-cart-button').forEach(function(button) {
button.addEventListener('click', function(event) {
  var productId = button.getAttribute('data-product-id');
  
  // Captura a seleção do tamanho e cor do produto dentro da div do produto
  var size = document.querySelector(`input[name="size-${productId}"]:checked`);
  var color = document.querySelector(`input[name="color-${productId}"]:checked`);
  
  if (size && color) {
    var selectedSize = size.value;
    var selectedColor = color.value;

    // Exibe as seleções do usuário para depuração
    console.log("Tamanho selecionado:", selectedSize);
    console.log("Cor selecionada:", selectedColor);

    // Encontre a div de variantes específica para o produto
    var productOptionsDiv = document.querySelector(`.product-options[data-product-id="${productId}"]`);
    if (!productOptionsDiv) {
      console.error('Produto não encontrado para variantes:', productId);
      return;
    }

    // Verifique o valor de data-variants
    var variantsString = productOptionsDiv.getAttribute('data-variants');
    console.log("Variants String:", variantsString); // Log para verificar o JSON

    // Tente fazer o parse do JSON e capturar erros
    try {
      var productVariants = JSON.parse(variantsString);
      console.log("Variants JSON:", productVariants); // Verifica a estrutura do JSON
    } catch (e) {
      console.error('Erro ao fazer o parse do JSON:', e);
      return;
    }
    
    // Agora buscamos a variante correta
    var selectedVariant = productVariants.find(function(variant) {
      console.log("Comparando:", variant.option1, variant.option2);

      // Garantir que estamos fazendo a comparação correta de tamanho e cor
      return variant.option1 === selectedSize && variant.option2 === selectedColor;
    });

    if (selectedVariant) {
      // Adicionar a variante ao carrinho usando a API do Shopify
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: selectedVariant.id,
            quantity: 1
          }]
        })
      }).then(response => {
        alert('Produto adicionado ao carrinho!');
      }).catch(error => {
        console.error('Erro ao adicionar ao carrinho:', error);
      });
    } else {
      console.error('Seleção inválida de variante');
      alert('Seleção inválida de variante.');
    }
  } else {
    alert('Por favor, selecione uma cor e um tamanho.');
  }
});
});

*/

